import { Box, Typography, Button } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Header from "./Header";
import { useEffect, useState } from "react";
import API from "../api";

const NotifyTable = () => {
  const [notifications, setNotifications] = useState([]);
  const [charged, setCharged] = useState(false)


  useEffect(() => {
    API.getNotification().then((response) => {
      setNotifications(response.data);
      setCharged(true);
    });
  }, []);

  const NotificationType3 = notifications
    .filter((notificationGroup) => notificationGroup.tipoEmail === 3)
    .flatMap((item) => item.notifiche)
    .map((notification) => ({
      id: notification._id,
      ...notification,
      tE: 3,
    }));
  const NotificationType9 = notifications
    .filter((notificationGroup) => notificationGroup.tipoEmail === 9)
    .flatMap((item) => item.notifiche)
    .map((notification) => ({
      id: notification._id,
      ...notification,
      tE: 9,
    }));
  const NotificationType8 = notifications
    .filter((notificationGroup) => notificationGroup.tipoEmail === 8)
    .flatMap((item) => item.notifiche)
    .map((notification) => ({
      id: notification._id,
      ...notification,
      tE: 8,
    }));

  const [
    combinedNotification = [
      ...NotificationType3,
      ...NotificationType9,
      ...NotificationType8,
    ],
    setNotificationsState,
  ] = useState();

  combinedNotification.sort((a, b) => {
    const dateA = new Date(
      a.timeStamp.split(" ")[0].split("/").reverse().join("-") +
      " " +
      a.timeStamp.split(" ")[1]
    );
    const dateB = new Date(
      b.timeStamp.split(" ")[0].split("/").reverse().join("-") +
      " " +
      b.timeStamp.split(" ")[1]
    );
    return dateB - dateA;
  });

  const columns = [
    {
      field: "timeStamp",
      headerName: "TIME STAMP",
      flex: 1,
      minWidth: 140,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "descrizione",
      headerName: "DESCRIPTION",
      flex: 1,
      minWidth: 500,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        let cellStyle = {};
        const cellValueLower = params.row.tE;
        if (cellValueLower === 8) {
          cellStyle = { color: "red" };
        } else if (cellValueLower === 3) {
          cellStyle = { color: "yellow" };
        } else if (cellValueLower === 9) {
          cellStyle = { color: "orange" };
        }
        return (
          <div style={{ ...cellStyle, width: "auto" }}>{params.value}</div>
        );
      },
    },
    {
      field: "matricola",
      headerName: "SERIAL NUMBER",
      flex: 1,
      minWidth: 145,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "letturaNotifiche",
      headerName: "READ",
      flex: 1,
      minWidth: 100,
      headerAlign: "left",
      align: "left",
      renderCell: (cellParams) => {
        if (cellParams.value === "NotRead") {
          const handleClick = () => {
            const updatedNotificationState = combinedNotification.map(
              (notif) => {
                if (
                  notif._id === cellParams.row._id &&
                  notif.letturaNotifiche === "NotRead"
                ) {
                  API.updateNotify({ id: cellParams.row._id });
                  return { ...notif, letturaNotifiche: "read" };
                }
                return notif;
              }
            );
            setNotificationsState(updatedNotificationState);
          };

          return (
            <Button
              onClick={handleClick}
              sx={{
                padding: 0,
                textTransform: "none",
                backgroundColor: "transparent",
                color: "#D1C167",
                "&:hover": {
                  backgroundColor: "transparent !important",
                  color: "#131C2D",
                },
              }}
              style={{ fontWeight: "bold", fontSize: 15 }}
            >
              Mark as read
            </Button>
          );
        } else {
          return <Typography sx={{ fontWeight: 'bold', fontSize: 15 }}>Read</Typography>;
        }
        // Restituisci null o un altro elemento se il valore non è 'NotRead'
      },
      // Puoi aggiungere un'altra logica qui se vuoi gestire altri casi
    },
  ];

  return (
    <Box m="20px">
      <Header title="ALL YOUR NOTIFICATIONS" subtitle="" />
      <Box
        m="40px 0 0 0"
        height="73vh"
      >
        <DataGrid
          sx={{
            fontWeight: 900,
            height: "100%",
            width: "100%",
            borderRadius: 5,
            border: "solid 1px #459095",
            overflowX: "auto",
            "& .MuiDataGrid-root": {
              border: "none",
              backgroundColor: "transparent !important"
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: "#1D7B91",
              fontWeight: 900
            },
            "& .MuiDataGrid-toolbarContainer": {
              borderTopRightRadius: 17,
              borderTopLeftRadius: 17,
              gap: 4,
              backgroundColor: "#449095",
              color: "#1D7B91",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: "#449095",
              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20
            },
            "& .MuiCheckbox-root": {
              color: "#1D7B91 !important",
            },
            "& .MuiButtonBase-root": {
              color: "#fff !important",
            },
            "& .MuiCircularProgress-root": {
              color: "#5b9ba9 !important"
            },
            "& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell": {
              whiteSpace: "normal !important"
            },
            "& .MuiBadge-badge": {
              backgroundColor: '#dd8d16'
            },
            "& .MuiDataGrid-root .MuiDataGrid-container--bottom [role=row]": {
              background: "#D0D0D0 !important"
            },
            "& .MuiDataGrid-panelWrapper": {
              width: '600px !important'
            },
            "& .MuiDataGrid-overlayWrapperInner": {
              backgroundColor: '#1a1a1a !important'
            },
            "& .MuiDataGrid-virtualScrollerContent": {
              backgroundColor: '#1a1a1a !important'
            },
            "& .MuiDataGrid-filler": {
              backgroundColor: '#1a1a1a !important'
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 900
            },
            "& .MuiDataGrid-virtualScroller": {
              borderRadius: 0
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#449095",
            },
          }}
          rows={combinedNotification}
          columns={columns}
          slots={{ toolbar: GridToolbar }}
          loading={!charged}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
            },
          }}
        />
      </Box>
    </Box>
  );
};
export default NotifyTable;
